import React, { useState } from 'react';
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Select,
  MenuItem,
} from '@mui/material';

const initialLeftItems = [
  { id: 1, label: 'Role' },
  { id: 2, label: 'Super Admin' },
  { id: 3, label: 'Admin' },
  { id: 4, label: 'Manager' },
  { id: 5, label: 'Team Lead' },
  { id: 6, label: 'Editor' },
  { id: 7, label: 'Customer Support' },
];

const UserAccess = () => {
  const [leftItems, setLeftItems] = useState(initialLeftItems);
  const [rightItems, setRightItems] = useState<any[]>([]);

  const [checkedLeft, setCheckedLeft] = useState<number[]>([]);
  const [checkedRight, setCheckedRight] = useState<number[]>([]);

  const handleToggleLeft = (id: number) => {
    setCheckedLeft(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const handleToggleRight = (id: number) => {
    setCheckedRight(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const handleRightSwap = () => {
    const toMove = leftItems.filter(item => checkedLeft.includes(item.id));
    setRightItems(prev => [...prev, ...toMove]);
    setLeftItems(prev => prev.filter(item => !checkedLeft.includes(item.id)));
    setCheckedLeft([]);
  };

  const handleLeftSwap = () => {
    const toMove = rightItems.filter(item => checkedRight.includes(item.id));
    setLeftItems(prev => [...prev, ...toMove]);
    setRightItems(prev => prev.filter(item => !checkedRight.includes(item.id)));
    setCheckedRight([]);
  };

  const renderList = (
    items: any[],
    checkedItems: number[],
    toggle: (id: number) => void
  ) => {
    if (items.length === 0) {
      return (
        <Typography
          color="text.secondary"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 2, minHeight: '300px', border: '1px solid #ccc', borderRadius: '4px' }}
          
        >
          Empty
        </Typography>
      );
    }

    return (
      <List dense sx={{ border: '1px solid #ccc', borderRadius: '4px' }}>
        {items.map(item => (
          <ListItem
            key={item.id}
            component="button"
            onClick={() => toggle(item.id)}
            sx={{
              color: checkedItems.includes(item.id) ? '#010431' : '#696969',
              backgroundColor: checkedItems.includes(item.id) ? '#f7fcff' : 'transparent',
              '&:hover': {
                backgroundColor: '#f1f1f1',
              },
              border: 'none',
              width: '100%',
              textAlign: 'left',
              cursor: 'pointer',
            }}
          >
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    );
  };

  return (
    <>
    <Box className="headingBtnWrap">
            <Typography variant="h1">User Access</Typography>
          </Box>
      <Box component="form" className="roleWrap">
              <div className="form-control inputFieldWrap">
                  <label>User</label>
                  <Select
                    labelId="role-select-label"
                    id="role-select"
                    className='inputField'
                    displayEmpty
                    defaultValue=""
                  >
                <MenuItem value="">Select User</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
                <MenuItem value="editor">Editor</MenuItem>
                <MenuItem value="viewer">Viewer</MenuItem>
                <MenuItem value="guest">Guest</MenuItem>
              </Select>
              </div>
          </Box>

      <Box display="flex" justifyContent="space-between" alignItems="center" gap={4} className="userAccess">
        {/* Left List */}
        <Box className="leftList" sx={{ width: '40%' }}>
          <Typography variant="h6" gutterBottom>
            User Access
          </Typography>
          {renderList(leftItems, checkedLeft, handleToggleLeft)}
        </Box>

        {/* Swap Buttons */}
        <Box display="flex" flexDirection="column" justifyContent="center" gap={1}>
          <Button variant="contained" onClick={handleRightSwap} disabled={checkedLeft.length === 0} className='swapBtn'>
            &gt;&gt;
          </Button>
          <Button variant="contained" onClick={handleLeftSwap} disabled={checkedRight.length === 0} className='swapBtn'>
            &lt;&lt;
          </Button>
        </Box>

        {/* Right List */}
        <Box className="rightList" sx={{ width: '40%' }}>
          <Typography variant="h6" gutterBottom>
            Given Access
          </Typography>
          {renderList(rightItems, checkedRight, handleToggleRight)}
        </Box>
      </Box>
    </>
  );
};

export default UserAccess;
